import React from 'react';

const tlds = [
  'com', 'org', 'net', 'edu', 'gov', 'io', 'co', 'biz', 'info', 'xyz', 'ly', 'ai', 'app', 'dev', 'tech',
  'store', 'online', 'art', 'photo', 'club', 'design', 'link', 'wiki', 'media', 'news', 'blog', 'social',
  'finance', 'marketing', 'agency', 'solutions', 'consulting', 'services', 'studio', 'events', 'life',
  'today', 'world', 'community', 'group', 'cafe', 'moda', 'lat',
].join('|');

const urlRegex = new RegExp(`((?:https?://|www\\.)[^\\s/$.?#].[^\\s]*|\\b[a-zA-Z0-9-]+\\.(?:${tlds})\\b(?:/[^\\s]*)?)`, 'g');

export default function renderTextWithLinks(text: string | undefined | null) {
  if (!text) {
    return null;
  }

  return text.split('\n').map((line, lineIndex, lineArray) => (
    <div key={lineIndex}>
      {line.split(' ').map((word, wordIndex, wordsArray) => {
        const parts = word.split(urlRegex).map((part, partIndex) => {
          if (part && part.match(urlRegex)) {
            let href = part;
            const punctuation = part.match(/[.,;!?:]*$/)?.[0] || '';
            const cleanUrl = punctuation ? part.slice(0, -punctuation.length) : part;

            if (!cleanUrl.startsWith('http') && !cleanUrl.startsWith('www.')) {
              href = `//${cleanUrl}`;
            } else if (cleanUrl.startsWith('www.')) {
              href = `//${cleanUrl}`;
            } else {
              href = cleanUrl;
            }

            return (
              <React.Fragment key={partIndex}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:underline"
                >
                  {cleanUrl}
                </a>
                {punctuation}
              </React.Fragment>
            );
          }
          return part;
        });
        const isLastWord = wordIndex === wordsArray.length - 1;
        return <React.Fragment key={wordIndex}>{parts}{!isLastWord && ' '}</React.Fragment>;
      })}
      {lineIndex !== lineArray.length - 1 && <br />}
    </div>
  ));
}
